import { gspx } from '@rsos/capstone';

export const trackClickStreetView = (
  irpVersion,
  payloadID,
  requestID,
  portalType,
) => {
  gspx.trackCustomEvent('Jurisdiction View', {
    irpVersion,
    name: `Click Street View button (ESRI MAP)`,
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
    payloadID,
    requestID,
    portalType,
  });
};
export const trackClickEstimatedFloorLevel = (
  irpVersion,
  payloadID,
  requestID,
  portalType,
) => {
  gspx.trackCustomEvent('Jurisdiction View', {
    irpVersion,
    name: `Open Estimated Floor Level`,
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
    payloadID,
    requestID,
    portalType,
  });
};
